import React from "react";
import { IIcon, Pill, IconMedal, IconException, IconThumbsUp, IconClose, IconWarning } from "@geotab/zenith";
import type { TPillType } from "@geotab/zenith/dist/utils/pillUtils/getPillTypeClassName";

import { useTranslationContext } from "../../../../../ui/framework/hooks/TranslationContext";

export enum RiskPillText {
    Best = "Best",
    Great = "Great",
    Average = "Average",
    Underperforming = "Underperforming",
    AtRisk = "At risk",
    NA = "N/A"
}

interface RiskFactorsPillProps {
    text: string;
}

export default function RiskFactorsPill({ text }: RiskFactorsPillProps): React.JSX.Element {
    const { translate } = useTranslationContext();
    let icon: React.FC<IIcon> | undefined;
    let type: TPillType;

    switch (text) {
        case RiskPillText.Best:
            icon = IconMedal;
            type = "success";
            break;
        case RiskPillText.Great:
        case RiskPillText.Average:
            icon = IconThumbsUp;
            type = "info";
            break;
        case RiskPillText.Underperforming:
            icon = IconWarning;
            type = "warning";
            break;
        case RiskPillText.AtRisk:
            icon = IconException;
            type = "error";
            break;
        case RiskPillText.NA:
        default:
            icon = IconClose;
            type = "warning";
            break;
    }

    return (
        <div>
            <Pill type={type} size="fullWidth" {...{ icon }}>
                {translate(text)}
            </Pill>
        </div>
    );
}

export const TRANSLATIONS: string[] = [RiskPillText.Best, RiskPillText.Great, RiskPillText.Average, RiskPillText.Underperforming, RiskPillText.AtRisk, RiskPillText.NA];
